import { IconToggleFavoriteOn12, UIHeading5 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './SuperAgentBadge.css';

export type TSuperAgentBadgeProps = {
  levelName: string;
};

export const SuperAgentBadge = ({ levelName }: TSuperAgentBadgeProps) => {
  return (
    <div className={styles['wrapper']}>
      <div className={styles['circle']}>
        <IconToggleFavoriteOn12 color="white_100" />
      </div>
      <UIHeading5 color="success_100">{levelName}</UIHeading5>
    </div>
  );
};
